module.exports = __webpack_public_path__ + "static/media/jasper-pattern.47e8b9e8.svg";